import { evaluateCondition } from '@dynamic/ui';

import { useConfig, useDataContext } from '#/hooks';

/**
 * Hook that returns setting menu items that meet the conditions defined in the config.
 * @returns Context and list of available setting items
 */
export function useSettingsMenus() {
  const {
    more: { settings: configSettings },
  } = useConfig();
  const { getGeneralContext } = useDataContext();
  const context = getGeneralContext();
  const settingsToUse = configSettings.filter(
    (el) => !el.condition || evaluateCondition(el.condition, context || {})
  );

  return { settingsToUse };
}

export type SettingsRouteParams = {
  settingId?: string;
};
